import FormControl from '@mui/material/FormControl';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { TProFormValues } from './steps';

const OFFERING_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'RYC® Group Classes', label: 'RYC® Group Classes' },
  { value: 'RYC® One-on-One Sessions', label: 'RYC® One-on-One Sessions' },
];

type Props = {
  isPending: boolean;
};

export const ProDirectoryOfferingsCards: FC<Props> = ({ isPending }) => {
  const { control } = useFormContext<TProFormValues>();

  return (
    <Controller
      name="offerings"
      control={control}
      render={({ field, fieldState }) => {
        const value: string[] = field.value ?? [];

        return (
          <FormControl error={!!fieldState.error}>
            <ToggleButtonGroup
              value={value}
              size="small"
              color="info"
              disabled={isPending}
              onChange={(_, next: string[]) => field.onChange(next)}
              sx={{
                width: '100%',
                maxWidth: 400,
                height: 45,
                flexWrap: 'nowrap',
                '& .MuiToggleButtonGroup-firstButton': {
                  borderTopLeftRadius: 12,
                  borderBottomLeftRadius: 12,
                },
                '& .MuiToggleButtonGroup-lastButton': {
                  borderTopRightRadius: 12,
                  borderBottomRightRadius: 12,
                },
              }}
            >
              {OFFERING_OPTIONS.map(option => (
                <ToggleButton
                  key={option.value}
                  value={option.value}
                  sx={{
                    gap: 0.5,
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  {option.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
            {fieldState.error && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                {fieldState.error.message}
              </Typography>
            )}
          </FormControl>
        );
      }}
    />
  );
};
